import { render, staticRenderFns } from "./ProductMods.vue?vue&type=template&id=25ca1716"
import script from "./ProductMods.vue?vue&type=script&lang=js"
export * from "./ProductMods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports